/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint-disable import/no-unresolved */

import PropTypes from "prop-types";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import useSwiperRef from "helpers/hooks/useSwiperRef";
import IconPrevious from "solar/icons/IconPrevious";
import IconNext from "solar/icons/IconNext";
import Container from "solar/components/Container";
import styles from "components/shared/stays/Carousel.module.scss";

export default function Carousel({
  slidePerLg = 2,
  title = null,
  filters = null,
  link = null,
  autoHeight = false,
  length = 2,
  children,
  breakpoints = null,
  showPagination = true,
}) {
  const breakpoint = 1024; // rt: should probably pull from a token
  const defaultBreakpoints = {
    0: {
      slidesPerView: 1.25,
    },
    [breakpoint]: {
      slidesPerView: slidePerLg,
      slidesPerGroup: slidePerLg,
    },
  };
  const greaterThanBreakpoint = useMediaQuery({
    query: `(min-width: ${breakpoint}px)`,
  });

  const [paginationEl, paginationElRef] = useSwiperRef();
  const [nextEl, nextElRef] = useSwiperRef();
  const [prevEl, prevElRef] = useSwiperRef();

  const slides = React.Children.toArray(children);

  return (
    <div className={styles.component}>
      <div className={styles.controls}>
        {title && <div className={styles.title}>{title}</div>}
        {filters && <div className={styles.filters}>{filters}</div>}
        <div className={styles.tools}>
          {link && <div className={styles.link}>{link}</div>}
          {showPagination && (
            <div className={styles.pagination} ref={paginationElRef} />
          )}
          <div className={styles.navigation}>
            <button type="button" ref={prevElRef}>
              <IconPrevious />
            </button>
            <button type="button" ref={nextElRef}>
              <IconNext />
            </button>
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.overrides}>
          {length > 1 ? (
            <Swiper
              modules={[Navigation]}
              breakpoints={breakpoints || defaultBreakpoints}
              cssMode={true && !greaterThanBreakpoint}
              watchOverflow
              simulateTouch={false}
              autoHeight={autoHeight}
              pagination={{
                el: paginationEl,
                type: "fraction",
                lockClass: styles.lock,
              }}
              navigation={{
                prevEl,
                nextEl,
                lockClass: styles.lock,
                disabledClass: styles.disabled,
              }}
            >
              {slides.map((item) => (
                <SwiperSlide key={item.key} className={styles.slide}>
                  {item}
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Container>{slides}</Container>
          )}
        </div>
      </div>
    </div>
  );
}

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
  breakpoints: PropTypes.shape({}),
  slidePerLg: PropTypes.node,
  title: PropTypes.node,
  filters: PropTypes.node,
  link: PropTypes.node,
  autoHeight: PropTypes.bool,
  length: PropTypes.number,
  showPagination: PropTypes.bool,
};
